import minMax from '../helpers/min-max';
import HSBColor from '../classes/hsb-color';

const hsl2hsb = ({ hue: h, saturation, lightness, alpha }) => {
  const a = saturation * (lightness < 0.5 ? lightness : 1 - lightness);

  const b = minMax(lightness + a, 0, 1);
  const s = minMax(b > 0 ? (2 * a) / b : 0, 0, 1);
  return new HSBColor(h, s, b, alpha);
};

export default hsl2hsb;
